export const MY_ROUTES = 'MY_ROUTES';
export const MY_ROUTES_LOCALSTORAGE = 'userData_myRoutes';

export const MY_ROUTE_MAX_LENGTH = 50;
